export const createGameReplaySlice = (gameReplay)=>(set, get)=>({
            gameReplay: {
                isReplay: gameReplay.isReplay,
                setIsReplay: (isReplay)=>{
                    set({
                        gameReplay: {
                            ...get().gameReplay,
                            isReplay: isReplay
                        }
                    });
                },
                actionIndex: -1,
                setActionIndex: (actionIndex)=>{
                    set({
                        gameReplay: {
                            ...get().gameReplay,
                            actionIndex: actionIndex
                        }
                    });
                },
                focusedLogIndex: null,
                setFocusedLogIndex: (logIndex)=>{
                    set({
                        gameReplay: {
                            ...get().gameReplay,
                            focusedLogIndex: logIndex
                        }
                    });
                },
                setReplayControls: (controls)=>{
                    set({
                        gameReplay: {
                            ...get().gameReplay,
                            replayControls: controls
                        }
                    });
                }
            }
        });
